import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    autoComplete: {
      '& .MuiInputBase-root': {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
    details: {
      padding: theme.spacing(2),
      margin: theme.spacing(1),
      background: theme.palette.background.default,
      border: `1px ${theme.palette.grey[400]} solid`,
      borderRadius: 5,
    },
  });
});
